import { render } from "./FireBackButton.vue?vue&type=template&id=69c312c1&scoped=true"
import script from "./FireBackButton.vue?vue&type=script&lang=ts"
export * from "./FireBackButton.vue?vue&type=script&lang=ts"

import "./FireBackButton.vue?vue&type=style&index=0&id=69c312c1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69c312c1"

export default script